export default "__VITE_ASSET__d2d71ee0__$_?component__"